import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EngineType } from '../../../../../api/types';

const useFinanceProductEngineTypeOptions = () => {
    const { t } = useTranslation('common');

    return useMemo(
        () => [
            {
                value: EngineType.Petrol,
                label: t('common:options.engineType.petrol'),
            },
            {
                value: EngineType.Electric,
                label: t('common:options.engineType.electric'),
            },
            {
                value: EngineType.Hybrid,
                label: t('common:options.engineType.hybrid'),
            },
            {
                value: EngineType.Diesel,
                label: t('common:options.engineType.diesel'),
            },
        ],
        [t]
    );
};

export default useFinanceProductEngineTypeOptions;
